export const EDIT_EMAIL_LOGIN = 'EDIT_EMAIL_LOGIN';
export const EDIT_PASSWORD = 'EDIT_PASSWORD';
export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';
export const LOGIN_BUTTON_SWITCH = 'LOGIN_BUTTON_SWITCH';
